'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on('click', '.dropdown-toggle', function (e) {
  e.preventDefault();

  var $parent = (0, _jquery2.default)(this).parent();

  if ($parent.hasClass('open')) {
    $parent.removeClass('open');
  } else {
    if ((0, _jquery2.default)(this).closest('.open').length === 0) {
      (0, _jquery2.default)('.dropdown').removeClass('open');
    }

    $parent.addClass('open');
  }
});

// event
(0, _jquery2.default)(document).on('click', function (e) {
  if ((0, _jquery2.default)(e.target).closest('.dropdown').length || (0, _jquery2.default)(e.target).closest('.btn-group').length) return;

  (0, _jquery2.default)('.dropdown, .btn-group').removeClass('open');
});

// for menu in mobile
(0, _jquery2.default)(document).on('click', '.navbar-toggle', function () {
  (0, _jquery2.default)(this).toggleClass('open');
  (0, _jquery2.default)('.navbar-collapse').toggleClass('open');
});

// for filter list in list/category etc.
(0, _jquery2.default)(document).on('click', '[data-panel-id]', function () {
  var id = (0, _jquery2.default)(this).attr('data-panel-id');

  // disable close if something inside box is checked
  if ((0, _jquery2.default)(id + ' input:checked').length == 0) {
    (0, _jquery2.default)(this).toggleClass('closed');

    (0, _jquery2.default)(id).slideToggle();
  } else {}
});

(0, _jquery2.default)(document).on('click', '#show-filters-mobile', function () {

  (0, _jquery2.default)(this).toggleClass('btn-orange');

  (0, _jquery2.default)(this).next().toggleClass('open').slideToggle();

  if ((0, _jquery2.default)(this).next().hasClass('open')) {
    (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-close'));
  } else {
    (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-open'));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  (0, _jquery2.default)("select#NewsAndEventTypeId").on('select2:select', function (event) {
    var selectedValue = (0, _jquery2.default)(event.target).select2().val();

    var referenceElement = document.getElementById('Reference') || {};
    var parentReference = referenceElement.parentElement || {};
    var prefix = parentReference.querySelector('.input-group-addon') || {};

    var bannerTypeIds = (document.getElementById('bannerTypeIds') || '').value.split(',');

    if (bannerTypeIds.some(function (b) {
      return b === selectedValue;
    })) {
      prefix.style.display = 'none';
      referenceElement.interuptKebabProcess = true;
    } else {
      prefix.style.display = '';
      referenceElement.interuptKebabProcess = false;
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/dropdown.js
// module id = 427
// module chunks = 0